import styled from "@emotion/styled";
import { RadioButtonContainerProps } from "./RadioButton.types";
import { generateRadioButtonStyles } from "../../utils";

export const RadioButtonStyled = styled.input`
  display: none; /* Hides the default radio input */
`;

export const RadioButtonContainer = styled.div<RadioButtonContainerProps>`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${(props) => generateRadioButtonStyles(props).borderColor};
`;

export const RadioButtonWrapper = styled.div`
  display: flex;
  gap: 8px; /* Space between the radio button and the label */
  justify-content: center;
  align-items: center;
`;

export const RadioIcon = styled.div<RadioButtonContainerProps>`
  width: 12px;
  height: 12px;
  border-radius: 50%; /* Inner circle */
  background-color: ${(props) =>
    generateRadioButtonStyles(props).backgroundColor}; /* Apply background */
  transition: all 0.3s ease; /* Smooth transition for background color and opacity */
`;
